module.exports = __webpack_public_path__ + "img/img-video.72f489e0.png";